import React from 'react';

import { useRouter } from 'next/router';
import { Icon } from 'components';
import { ButtonV3 } from 'components/ComponentV2';

import { PAGE_ROUTES } from 'lib/page-routes';
import styles from './MessagesEmptyState.module.scss';

export const MessagesEmptyState: React.FC = () => {
  const router = useRouter();

  const onExploreOpportunities = () => router.push(PAGE_ROUTES.SEARCH_RESULTS);

  return (
    <div className={styles.MessagesEmptyState}>
      <div className={styles.MessagesEmptyStateWrapper}>
        <Icon iconName="desert" size="auto" />
        <div className={styles.MessagesEmptyStateContent}>
          <p className={styles.title}>No messages yet</p>
          <p className={styles.caption}>
            Apply and register for jobs, internships and events and soon enough
            your inbox will be buzzing with exciting messages.
          </p>
        </div>
        <div className={styles.MessagesEmptyStateAction}>
          <ButtonV3
            size="large"
            onClick={onExploreOpportunities}
            startIcon="search"
          >
            Explore opportunities
          </ButtonV3>
        </div>
      </div>
    </div>
  );
};
